'use es6';

import { updateParams } from './ReactRouter';
import getUrlParamsForDashboardDateRange from 'FormsUI/utils/date/getUrlParamsForDashboardDateRange';
import { getAnalyticsSelectedForms } from 'FormsUI/selectors/Dashboard';
function createAction(name) {
  return `@@dashboard/${name}`;
}
export const RECEIVE_ANALYTICS = createAction('RECEIVE_ANALYTICS');
export const SET_ANALYTICS_BUSINESS_UNIT_ID = createAction('SET_ANALYTICS_BUSINESS_UNIT_ID');
export const SET_ANALYTICS_DATE_RANGE = createAction('SET_ANALYTICS_DATE_RANGE');
export const SET_ANALYTICS_SELECTED_FORMS = createAction('SET_ANALYTICS_SELECTED_FORMS');
export const SET_ANALYTICS_SEARCH_QUERY = createAction('SET_ANALYTICS_SEARCH_QUERY');
const setAnalyticsBusinessUnit = ({
  businessUnitId
}) => ({
  type: SET_ANALYTICS_BUSINESS_UNIT_ID,
  businessUnitId
});
export const receiveAnalytics = () => {
  return {
    type: RECEIVE_ANALYTICS
  };
};
const setAnalyticsDateRange = ({
  range
}) => ({
  type: SET_ANALYTICS_DATE_RANGE,
  range
});
const setAnalyticsSelectedForms = ({
  formGuids
}) => ({
  type: SET_ANALYTICS_SELECTED_FORMS,
  formGuids
});
const setAnalyticsSearchQuery = ({
  query
}) => ({
  type: SET_ANALYTICS_SEARCH_QUERY,
  query
});
export function changeAnalyticsDateRange(range) {
  return dispatch => {
    dispatch(updateParams(getUrlParamsForDashboardDateRange(range)));
    dispatch(setAnalyticsDateRange({
      range
    }));
  };
}
export function changeAnalyticsSelectedForms(newFormGuid) {
  return (dispatch, getState) => {
    const state = getState();
    const prevSelectedGuids = getAnalyticsSelectedForms(state);
    let formGuids;
    if (prevSelectedGuids.includes(newFormGuid)) {
      formGuids = prevSelectedGuids.filter(formGuid => formGuid !== newFormGuid);
    } else {
      formGuids = [...prevSelectedGuids, newFormGuid];
    }
    dispatch(setAnalyticsSelectedForms({
      formGuids
    }));
  };
}
export function changeAnalyticsBusinessUnit(businessUnitId) {
  return dispatch => {
    dispatch(setAnalyticsBusinessUnit({
      businessUnitId
    }));
  };
}
export function changeAnalyticsSearchQuery(query) {
  return dispatch => {
    dispatch(setAnalyticsSearchQuery({
      query
    }));
  };
}